<div class="ajutoare-stats-bar">
    <span class="ajutoare-stats-bar__label">
        Ajutoare — {{ totalCount }} {{ totalLabel }}:
    </span>

    <div class="ajutoare-stats-bar__pills" *ngIf="activeStats.length > 0; else emptyState">
        <button
            *ngFor="let stat of activeStats; trackBy: trackByKey"
            type="button"
            class="stat-pill"
            [ngClass]="'stat-pill--' + stat.color"
            [class.stat-pill--active]="activeKey === stat.key"
            (click)="onPillClick(stat.key)"
            [attr.aria-label]="'Filtrează după ' + stat.label + ': ' + stat.count + ' cereri'">
            <span class="stat-pill__count">{{ stat.count }}</span>
            <span class="stat-pill__label">{{ stat.label.toLowerCase() }}</span>
        </button>

        <button
            *ngIf="activeKey"
            type="button"
            class="stat-pill-reset"
            (click)="onReset()"
            aria-label="Resetează filtru">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <ng-template #emptyState>
        <span class="ajutoare-stats-bar__empty">
            Nicio cerere activă în momentul de față
        </span>
    </ng-template>

    <button
        mat-stroked-button
        type="button"
        class="ajutoare-stats-bar__view-all"
        (click)="openModal()">
        Vezi toate stările
        <mat-icon style="font-size:14px;width:14px;height:14px">open_in_new</mat-icon>
    </button>
</div>
